import { render, staticRenderFns } from "./TbJingYing.vue?vue&type=template&id=3df0c86a&scoped=true"
import script from "./TbJingYing.vue?vue&type=script&lang=js"
export * from "./TbJingYing.vue?vue&type=script&lang=js"
import style0 from "./TbJingYing.vue?vue&type=style&index=0&id=3df0c86a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0c86a",
  null
  
)

export default component.exports